/**
 * Codebox Registry 默认配置
 */

export const REGISTRY_DEFAULTS = {
  // API 服务器配置
  api: {
    port: parseInt(process.env.CODEBOX_REGISTRY_PORT || '9091'),
    host: process.env.CODEBOX_REGISTRY_HOST || 'localhost',
    enabled: true
  },

  // 数据库配置
  database: {
    type: 'sqlite' as const,
    path: process.env.CODEBOX_REGISTRY_DB_PATH || './data/codebox-registry.db'
  },

  // 健康检查配置
  healthCheck: {
    enabled: true,
    defaultInterval: 30000, // 30秒
    defaultTimeout: 5000,   // 5秒
    defaultRetries: 3
  },

  // 监控配置
  monitoring: {
    retentionDays: 30,
    metricsInterval: 60000 // 1分钟
  },

  // Registry 存储路径
  registry: {
    storagePath: process.env.CODEBOX_REGISTRY_STORAGE || './data/registry'
  }
};

/**
 * 获取数据库路径
 */
export function getDatabasePath(): string {
  // 在生产环境中，使用用户主目录
  if (process.env.NODE_ENV === 'production') {
    const homeDir = process.env.HOME || process.env.USERPROFILE || '.';
    return `${homeDir}/.codebox/registry.db`;
  }
  return REGISTRY_DEFAULTS.database.path;
}

/**
 * 获取存储路径
 */
export function getStoragePath(): string {
  // 在生产环境中，使用用户主目录
  if (process.env.NODE_ENV === 'production') {
    const homeDir = process.env.HOME || process.env.USERPROFILE || '.';
    return `${homeDir}/.codebox/registry`;
  }
  return REGISTRY_DEFAULTS.registry.storagePath;
}